/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _module_registration__why_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Pourquoi utiliser [b]Go Africa Online[/b] ?' }],
    'fr',
);

const _module_registration__why_en = new IntlMessageFormat(
    [{ type: 0, value: 'Why choose [b]Go Africa Online[/b]?' }],
    'en',
);

export function module_registration__why(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__why_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__why_en.format(args) as unknown as string;
    }

    return _module_registration__why_fr.format(args) as unknown as string;
}

const _module_registration__you_are_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vous êtes' }],
    'fr',
);

const _module_registration__you_are_en = new IntlMessageFormat(
    [{ type: 0, value: 'You are' }],
    'en',
);

export function module_registration__you_are(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__you_are_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__you_are_en.format(args) as unknown as string;
    }

    return _module_registration__you_are_fr.format(args) as unknown as string;
}

const _module_registration__choice_pro_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Un professionnel' }],
    'fr',
);

const _module_registration__choice_pro_en = new IntlMessageFormat(
    [{ type: 0, value: 'An Independent Professional' }],
    'en',
);

export function module_registration__choice_pro(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__choice_pro_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__choice_pro_en.format(args) as unknown as string;
    }

    return _module_registration__choice_pro_fr.format(args) as unknown as string;
}

const _module_registration__choice_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Une société' }],
    'fr',
);

const _module_registration__choice_company_en = new IntlMessageFormat(
    [{ type: 0, value: 'A Company' }],
    'en',
);

export function module_registration__choice_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__choice_company_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__choice_company_en.format(args) as unknown as string;
    }

    return _module_registration__choice_company_fr.format(args) as unknown as string;
}

const _module_registration__find_clients_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Trouvez vos futurs clients' }],
    'fr',
);

const _module_registration__find_clients_en = new IntlMessageFormat(
    [{ type: 0, value: 'Find new clients' }],
    'en',
);

export function module_registration__find_clients(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__find_clients_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__find_clients_en.format(args) as unknown as string;
    }

    return _module_registration__find_clients_fr.format(args) as unknown as string;
}

const _module_registration__sell_products_services_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Vendez vos produits et services' }],
    'fr',
);

const _module_registration__sell_products_services_en = new IntlMessageFormat(
    [{ type: 0, value: 'Sell your products and services' }],
    'en',
);

export function module_registration__sell_products_services(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__sell_products_services_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__sell_products_services_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__sell_products_services_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__promote_brand_image_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Diffusez votre image de marque' }],
    'fr',
);

const _module_registration__promote_brand_image_en = new IntlMessageFormat(
    [{ type: 0, value: 'Boost your brand image' }],
    'en',
);

export function module_registration__promote_brand_image(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__promote_brand_image_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__promote_brand_image_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__promote_brand_image_fr.format(args) as unknown as string;
}

const _module_registration__access_local_talents_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Accédez à un vivier de talents locaux' }],
    'fr',
);

const _module_registration__access_local_talents_en = new IntlMessageFormat(
    [{ type: 0, value: 'Tap into local talent pools' }],
    'en',
);

export function module_registration__access_local_talents(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__access_local_talents_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__access_local_talents_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__access_local_talents_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__create_community_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Créez votre propre communauté' }],
    'fr',
);

const _module_registration__create_community_en = new IntlMessageFormat(
    [{ type: 0, value: 'Build your own community' }],
    'en',
);

export function module_registration__create_community(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__create_community_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__create_community_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__create_community_fr.format(args) as unknown as string;
}

const _module_registration__digitalize_communication_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Digitalisez votre communication' }],
    'fr',
);

const _module_registration__digitalize_communication_en = new IntlMessageFormat(
    [{ type: 0, value: 'Digitize your communication' }],
    'en',
);

export function module_registration__digitalize_communication(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__digitalize_communication_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__digitalize_communication_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__digitalize_communication_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__present_online_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Présentez votre profil en ligne' }],
    'fr',
);

const _module_registration__present_online_profile_en = new IntlMessageFormat(
    [{ type: 0, value: 'Showcase your online profile' }],
    'en',
);

export function module_registration__present_online_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__present_online_profile_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__present_online_profile_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__present_online_profile_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__share_professional_info_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Diffusez de l’information pro' }],
    'fr',
);

const _module_registration__share_professional_info_en = new IntlMessageFormat(
    [{ type: 0, value: 'Share industry insights' }],
    'en',
);

export function module_registration__share_professional_info(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__share_professional_info_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__share_professional_info_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__share_professional_info_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__build_subscriber_group_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Constituez vous un groupe d’abonnés' }],
    'fr',
);

const _module_registration__build_subscriber_group_en = new IntlMessageFormat(
    [{ type: 0, value: 'Grow your subscriber base' }],
    'en',
);

export function module_registration__build_subscriber_group(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__build_subscriber_group_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__build_subscriber_group_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__build_subscriber_group_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__attract_decision_makers_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Faites vous remarquer des décideurs' }],
    'fr',
);

const _module_registration__attract_decision_makers_en = new IntlMessageFormat(
    [{ type: 0, value: 'Get noticed by decision-makers' }],
    'en',
);

export function module_registration__attract_decision_makers(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__attract_decision_makers_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__attract_decision_makers_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__attract_decision_makers_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__apply_job_postings_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Postulez pour les annonces d’emploi' }],
    'fr',
);

const _module_registration__apply_job_postings_en = new IntlMessageFormat(
    [{ type: 0, value: 'Apply to job offers' }],
    'en',
);

export function module_registration__apply_job_postings(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__apply_job_postings_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__apply_job_postings_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__apply_job_postings_fr.format(args) as unknown as string;
}

const _module_registration__follow_sector_news_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Suivez l’information des secteurs qui vous intéressent' }],
    'fr',
);

const _module_registration__follow_sector_news_en = new IntlMessageFormat(
    [{ type: 0, value: 'Stay updated with industry trends' }],
    'en',
);

export function module_registration__follow_sector_news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__follow_sector_news_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__follow_sector_news_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__follow_sector_news_fr.format(args) as unknown as string;
}

const _module_registration__join_free_millions_members_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Rejoignez gratuitement des [b]millions de membres et d’entreprises africaines[/b]',
        },
    ],
    'fr',
);

const _module_registration__join_free_millions_members_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Join [b]millions of African professionals and businesses[/b] for free',
        },
    ],
    'en',
);

export function module_registration__join_free_millions_members(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__join_free_millions_members_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__join_free_millions_members_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__join_free_millions_members_fr.format(
        args,
    ) as unknown as string;
}

const _module_registration__first_name_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Prénom' }],
    'fr',
);

const _module_registration__first_name_en = new IntlMessageFormat(
    [{ type: 0, value: 'First name' }],
    'en',
);

export function module_registration__first_name(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__first_name_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__first_name_en.format(args) as unknown as string;
    }

    return _module_registration__first_name_fr.format(args) as unknown as string;
}

const _module_registration__last_name_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nom' }],
    'fr',
);

const _module_registration__last_name_en = new IntlMessageFormat(
    [{ type: 0, value: 'Last name' }],
    'en',
);

export function module_registration__last_name(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__last_name_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__last_name_en.format(args) as unknown as string;
    }

    return _module_registration__last_name_fr.format(args) as unknown as string;
}

const _module_registration__email_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Email' }],
    'fr',
);

const _module_registration__email_en = new IntlMessageFormat(
    [{ type: 0, value: 'Email' }],
    'en',
);

export function module_registration__email(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__email_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__email_en.format(args) as unknown as string;
    }

    return _module_registration__email_fr.format(args) as unknown as string;
}

const _module_registration__password_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mot de passe' }],
    'fr',
);

const _module_registration__password_en = new IntlMessageFormat(
    [{ type: 0, value: 'Password' }],
    'en',
);

export function module_registration__password(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__password_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__password_en.format(args) as unknown as string;
    }

    return _module_registration__password_fr.format(args) as unknown as string;
}

const _module_registration__register_company_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Souhaitez-vous également inscrire une société ?' }],
    'fr',
);

const _module_registration__register_company_en = new IntlMessageFormat(
    [{ type: 0, value: 'Would you also like to register a company?' }],
    'en',
);

export function module_registration__register_company(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__register_company_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__register_company_en.format(
            args,
        ) as unknown as string;
    }

    return _module_registration__register_company_fr.format(args) as unknown as string;
}

const _module_registration__i_accept_fr = new IntlMessageFormat(
    [{ type: 0, value: "J'accepte les" }],
    'fr',
);

const _module_registration__i_accept_en = new IntlMessageFormat(
    [{ type: 0, value: 'I accept the' }],
    'en',
);

export function module_registration__i_accept(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__i_accept_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__i_accept_en.format(args) as unknown as string;
    }

    return _module_registration__i_accept_fr.format(args) as unknown as string;
}

const _module_registration__cgu_fr = new IntlMessageFormat(
    [{ type: 0, value: 'conditions générales d’utilisation' }],
    'fr',
);

const _module_registration__cgu_en = new IntlMessageFormat(
    [{ type: 0, value: 'terms of use' }],
    'en',
);

export function module_registration__cgu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__cgu_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__cgu_en.format(args) as unknown as string;
    }

    return _module_registration__cgu_fr.format(args) as unknown as string;
}

const _module_registration__create_account_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Je créé mon compte' }],
    'fr',
);

const _module_registration__create_account_en = new IntlMessageFormat(
    [{ type: 0, value: 'Create my account' }],
    'en',
);

export function module_registration__create_account(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_registration__create_account_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_registration__create_account_en.format(args) as unknown as string;
    }

    return _module_registration__create_account_fr.format(args) as unknown as string;
}

const _module_superapp__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Une [b]super app[/b] professionnelle et multi-services' }],
    'fr',
);

const _module_superapp__title_en = new IntlMessageFormat(
    [{ type: 0, value: 'A [b]super app[/b] for professionals and services' }],
    'en',
);

export function module_superapp__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__title_en.format(args) as unknown as string;
    }

    return _module_superapp__title_fr.format(args) as unknown as string;
}

const _module_superapp__app_entreprises_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Entreprises' }],
    'fr',
);

const _module_superapp__app_entreprises_en = new IntlMessageFormat(
    [{ type: 0, value: 'Businesses' }],
    'en',
);

export function module_superapp__app_entreprises(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_entreprises_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_entreprises_en.format(args) as unknown as string;
    }

    return _module_superapp__app_entreprises_fr.format(args) as unknown as string;
}

const _module_superapp__app_professionnels_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Professionnels' }],
    'fr',
);

const _module_superapp__app_professionnels_en = new IntlMessageFormat(
    [{ type: 0, value: 'Professionals' }],
    'en',
);

export function module_superapp__app_professionnels(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_professionnels_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_professionnels_en.format(args) as unknown as string;
    }

    return _module_superapp__app_professionnels_fr.format(args) as unknown as string;
}

const _module_superapp__app_reseau_social_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Réseau social' }],
    'fr',
);

const _module_superapp__app_reseau_social_en = new IntlMessageFormat(
    [{ type: 0, value: 'Social Network' }],
    'en',
);

export function module_superapp__app_reseau_social(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_reseau_social_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_reseau_social_en.format(args) as unknown as string;
    }

    return _module_superapp__app_reseau_social_fr.format(args) as unknown as string;
}

const _module_superapp__app_messagerie_privee_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Messagerie privée' }],
    'fr',
);

const _module_superapp__app_messagerie_privee_en = new IntlMessageFormat(
    [{ type: 0, value: 'Private Messaging' }],
    'en',
);

export function module_superapp__app_messagerie_privee(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_messagerie_privee_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_messagerie_privee_en.format(
            args,
        ) as unknown as string;
    }

    return _module_superapp__app_messagerie_privee_fr.format(args) as unknown as string;
}

const _module_superapp__app_emploi_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Emploi' }],
    'fr',
);

const _module_superapp__app_emploi_en = new IntlMessageFormat(
    [{ type: 0, value: 'Jobs' }],
    'en',
);

export function module_superapp__app_emploi(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_emploi_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_emploi_en.format(args) as unknown as string;
    }

    return _module_superapp__app_emploi_fr.format(args) as unknown as string;
}

const _module_superapp__app_medias_articles_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Médias / Articles' }],
    'fr',
);

const _module_superapp__app_medias_articles_en = new IntlMessageFormat(
    [{ type: 0, value: 'Media / Articles' }],
    'en',
);

export function module_superapp__app_medias_articles(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_superapp__app_medias_articles_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_superapp__app_medias_articles_en.format(args) as unknown as string;
    }

    return _module_superapp__app_medias_articles_fr.format(args) as unknown as string;
}

const _module_gao_presentation__members_fr = new IntlMessageFormat(
    [{ type: 0, value: 'membres' }],
    'fr',
);

const _module_gao_presentation__members_en = new IntlMessageFormat(
    [{ type: 0, value: 'members' }],
    'en',
);

export function module_gao_presentation__members(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__members_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__members_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__members_fr.format(args) as unknown as string;
}

const _module_gao_presentation__businesses_fr = new IntlMessageFormat(
    [{ type: 0, value: 'entreprises' }],
    'fr',
);

const _module_gao_presentation__businesses_en = new IntlMessageFormat(
    [{ type: 0, value: 'businesses' }],
    'en',
);

export function module_gao_presentation__businesses(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__businesses_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__businesses_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__businesses_fr.format(args) as unknown as string;
}

const _module_gao_presentation__page_views_fr = new IntlMessageFormat(
    [{ type: 0, value: 'pages vues / mois' }],
    'fr',
);

const _module_gao_presentation__page_views_en = new IntlMessageFormat(
    [{ type: 0, value: 'page views / month' }],
    'en',
);

export function module_gao_presentation__page_views(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__page_views_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__page_views_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__page_views_fr.format(args) as unknown as string;
}

const _module_gao_presentation__visitors_per_year_fr = new IntlMessageFormat(
    [{ type: 0, value: 'de visiteurs / an' }],
    'fr',
);

const _module_gao_presentation__visitors_per_year_en = new IntlMessageFormat(
    [{ type: 0, value: 'visitors / year' }],
    'en',
);

export function module_gao_presentation__visitors_per_year(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__visitors_per_year_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__visitors_per_year_en.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__visitors_per_year_fr.format(
        args,
    ) as unknown as string;
}

const _module_gao_presentation__new_joiners_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ils viennent de nous rejoindre' }],
    'fr',
);

const _module_gao_presentation__new_joiners_en = new IntlMessageFormat(
    [{ type: 0, value: 'Recently joined us' }],
    'en',
);

export function module_gao_presentation__new_joiners(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__new_joiners_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__new_joiners_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__new_joiners_fr.format(args) as unknown as string;
}

const _module_gao_presentation__network_africa_fr = new IntlMessageFormat(
    [{ type: 0, value: "Entrez dans le plus grand réseau professionnel d'Afrique !" }],
    'fr',
);

const _module_gao_presentation__network_africa_en = new IntlMessageFormat(
    [{ type: 0, value: 'Join Africa’s largest professional network!' }],
    'en',
);

export function module_gao_presentation__network_africa(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__network_africa_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__network_africa_en.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__network_africa_fr.format(args) as unknown as string;
}

const _module_gao_presentation__register_fr = new IntlMessageFormat(
    [{ type: 0, value: "S'inscrire" }],
    'fr',
);

const _module_gao_presentation__register_en = new IntlMessageFormat(
    [{ type: 0, value: 'Sign up' }],
    'en',
);

export function module_gao_presentation__register(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__register_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__register_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__register_fr.format(args) as unknown as string;
}

const _module_gao_presentation__title_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Nous ne créons pas seulement des connexions [b]Nous bâtissons des opportunités[/b]',
        },
    ],
    'fr',
);

const _module_gao_presentation__title_en = new IntlMessageFormat(
    [{ type: 0, value: 'We don’t just connect people, [b]we create opportunities[/b]' }],
    'en',
);

export function module_gao_presentation__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__title_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__title_fr.format(args) as unknown as string;
}

const _module_gao_presentation__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Chez Go Africa Online, nous pensons que le développement du\ncontinent Africain passe par une progression des affaires\nréalisées par les acteurs économiques locaux. Internet, les\ninteractions sociales, l’intelligence artificielle : découvrez\ncomment nos services peuvent transformer vos affaires.\nRejoignez la communauté florissante d'entrepreneurs africains\nqui, grâce à nos services innovants, écrivent leur succès.",
        },
    ],
    'fr',
);

const _module_gao_presentation__text_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'At Go Africa Online, we believe Africa’s growth relies on empowering local businesses.\nDiscover how digital tools, networking, and AI can transform your business.\nJoin our thriving community of African entrepreneurs achieving success through our innovative services.',
        },
    ],
    'en',
);

export function module_gao_presentation__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__text_en.format(args) as unknown as string;
    }

    return _module_gao_presentation__text_fr.format(args) as unknown as string;
}

const _module_gao_presentation__shape_future_fr = new IntlMessageFormat(
    [{ type: 0, value: "Ensemble, façonnons l'avenir du continent" }],
    'fr',
);

const _module_gao_presentation__shape_future_en = new IntlMessageFormat(
    [{ type: 0, value: 'Together, let’s shape the continent’s future' }],
    'en',
);

export function module_gao_presentation__shape_future(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_gao_presentation__shape_future_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_gao_presentation__shape_future_en.format(
            args,
        ) as unknown as string;
    }

    return _module_gao_presentation__shape_future_fr.format(args) as unknown as string;
}

const _module_references__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Il nous font [b]confiance[/b]' }],
    'fr',
);

const _module_references__title_en = new IntlMessageFormat(
    [{ type: 0, value: 'They [b]trust[/b] us' }],
    'en',
);

export function module_references__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_references__title_en.format(args) as unknown as string;
    }

    return _module_references__title_fr.format(args) as unknown as string;
}

const _module_references__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Faites comme des [slot="link"][b]milliers d’entreprises[/b][/slot]\nqui gagnent de nouveaux clients grâce à une meilleure visibilité digitale. Profitez\nde la puissance des nos fonctionnalités premium [b]au service de votre croissance[/b].',
        },
    ],
    'fr',
);

const _module_references__text_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Join [slot="link"][b]thousands of companies[/b][/slot] gaining new clients thanks to improved digital visibility. Benefit from our premium tools [b]designed to grow your business[/b].',
        },
    ],
    'en',
);

export function module_references__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_references__text_en.format(args) as unknown as string;
    }

    return _module_references__text_fr.format(args) as unknown as string;
}

const _module_references__digital_visibility_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Plus de visibilité digitale ? Cliquez-ici !' }],
    'fr',
);

const _module_references__digital_visibility_en = new IntlMessageFormat(
    [{ type: 0, value: 'Want more visibility? Click here!' }],
    'en',
);

export function module_references__digital_visibility(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_references__digital_visibility_fr.format(
            args,
        ) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_references__digital_visibility_en.format(
            args,
        ) as unknown as string;
    }

    return _module_references__digital_visibility_fr.format(args) as unknown as string;
}

const _module_tendances__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Tendances sur [b]Go Africa Online[/b]' }],
    'fr',
);

const _module_tendances__title_en = new IntlMessageFormat(
    [{ type: 0, value: 'Trends on [b]Go Africa Online[/b]' }],
    'en',
);

export function module_tendances__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__title_en.format(args) as unknown as string;
    }

    return _module_tendances__title_fr.format(args) as unknown as string;
}

const _module_tendances__text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "[p]Professionnels, entreprises, salariés et étudiants d'Afrique, rejoignez le [b]réseau social professionnel[/b]\net profitez d’un espace d'échange, de partage d'idées, d’expertise et de\ncollaboration. Développez votre réseau, découvrez des opportunités d'affaires\net d'emploi, et restez à la pointe des tendances et des innovations sur le\ncontinent.[/p]\n[p]Rejoignez-nous pour façonner l'avenir professionnel de l'Afrique.[/p]",
        },
    ],
    'fr',
);

const _module_tendances__text_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: '[p]Professionals, companies, employees, and students across Africa—join the [b]professional social network[/b]\nand enjoy a space to exchange, share ideas, showcase expertise, and collaborate.\nGrow your network, explore business and job opportunities, and stay on top of innovations and trends across the continent.[/p]\n[p]Join us in building the future of professional Africa.[/p]',
        },
    ],
    'en',
);

export function module_tendances__text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__text_en.format(args) as unknown as string;
    }

    return _module_tendances__text_fr.format(args) as unknown as string;
}

const _module_tendances__title_companies_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Entreprises[/b] les plus suivies' }],
    'fr',
);

const _module_tendances__title_companies_en = new IntlMessageFormat(
    [{ type: 0, value: '[b]Top-followed[/b] companies' }],
    'en',
);

export function module_tendances__title_companies(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_companies_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__title_companies_en.format(args) as unknown as string;
    }

    return _module_tendances__title_companies_fr.format(args) as unknown as string;
}

const _module_tendances__title_publications_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Publications[/b] les plus tendances' }],
    'fr',
);

const _module_tendances__title_publications_en = new IntlMessageFormat(
    [{ type: 0, value: '[b]Trending[/b] posts' }],
    'en',
);

export function module_tendances__title_publications(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_publications_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__title_publications_en.format(args) as unknown as string;
    }

    return _module_tendances__title_publications_fr.format(args) as unknown as string;
}

const _module_tendances__title_pros_fr = new IntlMessageFormat(
    [{ type: 0, value: '[b]Professionnels[/b] les plus suivis' }],
    'fr',
);

const _module_tendances__title_pros_en = new IntlMessageFormat(
    [{ type: 0, value: '[b]Top-followed[/b] professionals' }],
    'en',
);

export function module_tendances__title_pros(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__title_pros_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__title_pros_en.format(args) as unknown as string;
    }

    return _module_tendances__title_pros_fr.format(args) as unknown as string;
}

const _module_tendances__join_free_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Rejoignez gratuitement des millions de membres et d’entreprises %ap%',
        },
    ],
    'fr',
);

const _module_tendances__join_free_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Join millions of professionals and businesses in %country% for free',
        },
    ],
    'en',
);

export function module_tendances__join_free(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__join_free_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__join_free_en.format(args) as unknown as string;
    }

    return _module_tendances__join_free_fr.format(args) as unknown as string;
}

const _module_tendances__register_fr = new IntlMessageFormat(
    [{ type: 0, value: "S'inscrire" }],
    'fr',
);

const _module_tendances__register_en = new IntlMessageFormat(
    [{ type: 0, value: 'Sign up' }],
    'en',
);

export function module_tendances__register(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_tendances__register_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_tendances__register_en.format(args) as unknown as string;
    }

    return _module_tendances__register_fr.format(args) as unknown as string;
}

const _module_articles__title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nos derniers [b]articles[/b]' }],
    'fr',
);

const _module_articles__title_en = new IntlMessageFormat(
    [{ type: 0, value: 'Our latest [b]articles[/b]' }],
    'en',
);

export function module_articles__title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_articles__title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_articles__title_en.format(args) as unknown as string;
    }

    return _module_articles__title_fr.format(args) as unknown as string;
}

const _module_articles__view_all_articles_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir tous les articles' }],
    'fr',
);

const _module_articles__view_all_articles_en = new IntlMessageFormat(
    [{ type: 0, value: 'See all articles' }],
    'en',
);

export function module_articles__view_all_articles(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _module_articles__view_all_articles_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _module_articles__view_all_articles_en.format(args) as unknown as string;
    }

    return _module_articles__view_all_articles_fr.format(args) as unknown as string;
}

const _meta_title_without_country_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Go Africa Online : Entreprises, emploi et réseau pro en Afrique',
        },
    ],
    'fr',
);

const _meta_title_without_country_en = new IntlMessageFormat(
    [{ type: 0, value: 'Go Africa Online | Business, Jobs & Professional Network' }],
    'en',
);

export function meta_title_without_country(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_title_without_country_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_title_without_country_en.format(args) as unknown as string;
    }

    return _meta_title_without_country_fr.format(args) as unknown as string;
}

const _meta_desc_without_country_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Trouvez vos fournisseurs, accédez aux offres d’emploi et développez votre réseau professionnel en Afrique avec Go Africa Online. Bien plus que des contacts',
        },
    ],
    'fr',
);

const _meta_desc_without_country_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Find suppliers, post a job, grow your professional network. Go Africa Online is your digital partner for success across the continent.',
        },
    ],
    'en',
);

export function meta_desc_without_country(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_desc_without_country_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_desc_without_country_en.format(args) as unknown as string;
    }

    return _meta_desc_without_country_fr.format(args) as unknown as string;
}

const _meta_title_with_country_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Go Africa Online %p% | Entreprises, emploi, réseau' }],
    'fr',
);

const _meta_title_with_country_en = new IntlMessageFormat(
    [{ type: 0, value: 'Go Africa Online %country% | Business, Jobs & Network' }],
    'en',
);

export function meta_title_with_country(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_title_with_country_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_title_with_country_en.format(args) as unknown as string;
    }

    return _meta_title_with_country_fr.format(args) as unknown as string;
}

const _meta_desc_with_country_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Trouvez vos fournisseurs, accédez aux offres d’emploi et développez votre réseau professionnel %pays_citoyen% avec Go Africa Online. C'est bien plus que des contacts",
        },
    ],
    'fr',
);

const _meta_desc_with_country_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Find suppliers, post a job, grow your professional network in %country%. Go Africa Online is your digital partner for success across the continent.',
        },
    ],
    'en',
);

export function meta_desc_with_country(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _meta_desc_with_country_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _meta_desc_with_country_en.format(args) as unknown as string;
    }

    return _meta_desc_with_country_fr.format(args) as unknown as string;
}
